import { render, staticRenderFns } from "./AllInventory.vue?vue&type=template&id=4bbcb18c&scoped=true&"
import script from "./AllInventory.vue?vue&type=script&lang=js&"
export * from "./AllInventory.vue?vue&type=script&lang=js&"
import style0 from "./AllInventory.vue?vue&type=style&index=0&id=4bbcb18c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbcb18c",
  null
  
)

export default component.exports